// src/pages/Contact.jsx
import React from "react";
import { FaInstagram } from "react-icons/fa";

const MAROON = "#800020";

export default function Contact() {
  return (
    <section className="min-h-screen bg-black text-white">
      <div className="w-full max-w-3xl mx-auto px-6 py-12 md:py-16 flex flex-col items-center gap-8">
        {/* Top image */}
        <div className="w-full max-w-lg rounded-2xl overflow-hidden border shadow-lg"
             style={{ borderColor: MAROON }}>
          <img
            src="/images/contact.jpeg"
            alt="Contact banner"
            className="w-full h-auto object-cover block"
          />
        </div>

        {/* Contact info */}
        <div className="text-center space-y-4">
          {/* Email placeholder */}
          <p className="text-lg md:text-xl font-medium">
            <span style={{ color: MAROON }}>Email:</span> mjmirashrafi@gmail.com
          </p>

          {/* Instagram link */}
          <a
            href="https://instagram.com/meloryjasmin"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-lg md:text-xl font-medium hover:opacity-80 transition-opacity"
            style={{ color: MAROON }}
          >
            <FaInstagram size={24} />
            @meloryjasmin
          </a>
        </div>
      </div>
    </section>
  );
}
